/**
 * Phone DOM-chrome scale knob — the runtime mirror of {@link computeChromeScale}.
 *
 * This is the SECOND, DOM-ONLY type knob (the decouple). It sets the
 * `--chrome-scale` CSS custom property on `#game-container`, which
 * `uiTokens.withUiScale` composes into every DOM font-size as
 * `calc(<px> * var(--ui-scale,1) * var(--chrome-scale,1))`.
 *
 * Why a separate knob from `utils/uiScale`: `setUiScale` drives BOTH the DOM
 * `--ui-scale` var AND the value `getUiScale()` returns to the canvas
 * (`rendering/canvasType`). Boosting chrome through it would also inflate
 * on-board canvas text (floating damage numbers, SEALED/SPAWN field labels).
 * `--chrome-scale` is a pure CSS variable that never reaches the 2D context, so
 * this knob moves the DOM chrome ALONE. Default `1` (index.html sets it
 * statically → no flash, byte-identical) — only the phone tier raises it.
 */

let chromeScale = 1;

/** The current DOM-chrome multiplier (default 1, no boost). */
export function getChromeScale(): number {
  return chromeScale;
}

/**
 * Set the DOM-chrome multiplier and mirror it onto `--chrome-scale` on
 * `#game-container`. Values ≤ 0 / non-finite are ignored (a transient NaN must
 * not collapse all chrome text to 0). Off-DOM (headless tests) it still updates
 * the JS source so {@link getChromeScale} stays truthful.
 */
export function setChromeScale(next: number): void {
  if (!(next > 0) || !Number.isFinite(next)) return;
  chromeScale = next;
  if (typeof document !== "undefined") {
    const root = document.getElementById("game-container");
    root?.style.setProperty("--chrome-scale", String(next));
  }
}
